import { ShopInfo } from "@/utils/shop";

export const getShopOptions = (contractId: number, shopInfo: ShopInfo[], shopPrefId: number): Option[] => {
  if (Array.isArray(shopInfo) && shopPrefId) {
    const newShopInfo: Option[] = [];
    shopInfo.map((shop: ShopInfo) => {
      if (
        shopPrefId &&
        shop.prefId &&
        shopPrefId.toString() === shop.prefId.toString() &&
        shop.contractId === contractId
      ) {
        newShopInfo.push({
          label: shop.name,
          value: shop.id.toString(),
        });
      }
    });
    return newShopInfo;
  } else {
    const newShopInfo: Option[] = [];
    shopInfo.map((shop: ShopInfo) => {
      newShopInfo.push({
        label: shop.name,
        value: shop.id.toString(),
      });
    });
    return newShopInfo;
  }
};

export const getShopPrefId = (shopInfo: ShopInfo[], shopId: string): number | undefined => {
  return shopInfo.find(shopInfo => shopInfo.id.toString() === shopId)?.prefId;
};

export const getShopById = (shopInfo: ShopInfo[], shopId: number) => {
  return shopInfo.find(shop => shop.id === shopId);
};
